enum ValuerTypeEnum {
    QUANTITY_SURVEYOR = 'QUANTITY_SURVEYOR',
    STANDARD = 'STANDARD',
}

export default ValuerTypeEnum;
